import React, {Component} from 'react';
import { Subscribe } from 'unstated';
import DataContainer from './data/data';

class Toolbar extends Component {
    render () {
        return (
            <Subscribe to={[DataContainer]}>
                {(DataContainer) => {
                    this.reset = () => {
                        DataContainer.reset();
                    }
                    this.print = () => {
                        DataContainer.setCurrentTeam(null).then(() =>{
                            window.print();
                        });
                    };
                    this.changeGender = () => {
                        DataContainer.changeGender();
                    }
                    return (

                        <div className="toolbar">
                            <button onClick={this.reset}>
                                reset
                            </button>
                            <button onClick={this.print}>
                                print 
                            </button>
                            <button onClick={this.changeGender}>
                                change to {DataContainer.getGender() === 'mens' ? "Women's" : "Men's"}
                            </button>
                        </div>
                    );
                }}
            </Subscribe>
        );
    }
}

export default Toolbar;